import { PropTypes } from 'prop-types'
import React, { useEffect } from 'react'
import { REPOSITORY } from '../../../api/repository/Repository'
import { Box, Button, Flex, Image, Text } from '@chakra-ui/react'
import ImageSuccess from '../../../assets/images/onboarding-success.png'
import ImageWarning from '../../../assets/images/onboarding-warning.png'
import { useAuthDispatch } from '../../../utils/login'
import { useNavigate } from 'react-router-dom'

export function StepFinal({ success = true, values }) {
  const dispatch = useAuthDispatch()
  const navigate = useNavigate()

  const messages = {
    success: {
      title: 'El cambio de contraseña se realizó con éxito.',
      text: '',
    },
    warning: {
      title: 'Lo sentimos, ocurrió un error.',
      text: 'Intenta nuevamente en unos minutos, si el problema persiste contáctanos a travez de nuestros canales digitales.',
    },
  }

  const formatMessage = (text, values) => {
    let message = text
    Object.keys(values).forEach((key) => {
      message = message.replace(`{${key}}`, values[key])
    })
    return message
  }

  const getMessage = () => {
    if (success) {
      return {
        title: messages.success.title,
        text: formatMessage(messages.success.text, values),
      }
    }
    return {
      title: messages.warning.title,
      text: formatMessage(messages.warning.text, values),
    }
  }

  useEffect(() => {
    if (success) {
      REPOSITORY.local.company.eraseData()
    }
  }, [])

  return (
    <Flex
      w="100%"
      justifyContent="center"
      pt={{ base: 0, sm: 0, md: 20 }}
      px={{ base: 0, sm: 0, md: 50 }}
    >
      <Box width={{ base: '100%', sm: '100%', md: 550 }}>
        <Flex
          mb={10}
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Image
            boxSize="fit-content"
            width={150}
            src={success ? ImageSuccess : ImageWarning}
            alt="amipass"
            marginBottom={{ base: 35, sm: 35, md: 0 }}
          />
          <Text
            my={10}
            textAlign="center"
            fontSize="3xl"
            mb={25}
            lineHeight={7}
          >
            {getMessage().title}
          </Text>
          <Text textAlign="center">{getMessage().text}</Text>
          {success && (
            <Button
              borderRadius={5}
              height={55}
              mt={7}
              justifyContent="center"
              onClick={() => {
                dispatch({ type: 'LOGOUT' })
                navigate('/login')
              }}
            >
              <Text fontWeight={600} fontSize={18} color="#ffffff">
                VOLVER A INGRESAR
              </Text>
            </Button>
          )}
        </Flex>
      </Box>
    </Flex>
  )
}

StepFinal.propTypes = {
  success: PropTypes.bool,
  values: PropTypes.object,
}
